import React from "react";
import Button from "../Button/Button.tsx";
import { Box, Typography } from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import { useLocation } from 'react-router-dom';

interface TopBarProps {
  onLogout: () => void;
  title?: string;
  actionButton?: {
    label: string;
    onClick: () => void;
    variant?: 'primary' | 'secondary';
  };
}

const TopBar: React.FC<TopBarProps> = ({ onLogout, title, actionButton }) => {
  const location = useLocation();

  // Get page title based on route
  const getPageTitle = () => {
    const path = location.pathname;
    if (title) return title;
    
    const titles: { [key: string]: string } = {
      '/dashboard': 'Dashboard',
      '/driver': 'Verified Drivers',
      '/vehicle': 'Vehicles',
      '/user': 'Users',
      '/active-driver': 'Active Drivers',
      '/test-numbers': 'Test Numbers',
      '/fare-management': 'Fare Management',
      '/support-requests': 'Support Requests',
      '/driver-verification': 'Driver Verification',
      '/rides': 'Rides'
    };
    
    return titles[path] || 'Mapto';
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 24px",
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #e0e0e0",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        height: "64px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flex: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: "#333",
            fontSize: "1.25rem",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {getPageTitle()}
        </Typography>
        {actionButton && (
          <Button 
            label={actionButton.label}
            onClick={actionButton.onClick}
            variant={actionButton.variant || "primary"}
          />
        )}
      </Box>

      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color: "#000000",
          fontSize: "1.5rem",
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        Mapto Auto & Cabs
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, justifyContent: 'flex-end' }}>
        <LogoutIcon sx={{ color: '#666', fontSize: '1.2rem' }} />
        <Button 
          label="Logout" 
          onClick={onLogout} 
          variant="primary"
        />
      </Box>
    </Box>
  );
};

export default TopBar;
